import { render, staticRenderFns } from "./requestLog.vue?vue&type=template&id=605fd143"
import script from "./requestLog.vue?vue&type=script&lang=ts"
export * from "./requestLog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports